import React from 'react';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-forest-green mb-4">
            About NorthPet Inc.
          </h1>
          <p className="text-xl text-moss-green italic">
            Adventure Awaits. Pets Included.
          </p>
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center mb-12">
            <div>
              <h2 className="text-3xl font-bold text-forest-green mb-6">
                Our Story
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                NorthPet Inc. is a strong, memorable, and emotionally resonant name that 
                immediately connects with pet lovers everywhere.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                <span className="font-semibold text-forest-green">"North"</span> evokes the wild, 
                the outdoors, and a sense of freedom and exploration, while{' '}
                <span className="font-semibold text-forest-green">"Pet"</span> grounds the brand 
                in its core mission—serving the needs of beloved animal companions.
              </p>
            </div>
            <div className="flex justify-center">
              <img 
                src="/NorthPetLogo.png" 
                alt="NorthPet Inc. Logo" 
                className="w-64 h-64 object-contain"
              />
            </div>
          </div>

          <div className="border-t border-gray-200 pt-8">
            <h2 className="text-3xl font-bold text-forest-green mb-6">
              Our Mission
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              At NorthPet, we believe pets are family, and they should be part of every fun moment, 
              trip, or daily walk. We're here to help make those moments even better. This 
              combination makes NorthPet ideal for an adventurous, nature-loving, and pet-focused 
              audience.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Every adventure is better with your pet, and we're committed to providing the best 
              products and experiences to support that belief.
            </p>
          </div>
        </div>

        {/* Values Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-forest-green text-white rounded-lg p-8">
            <h3 className="text-2xl font-bold mb-4">Our Values</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <span className="text-moss-green mr-2">🌲</span>
                <span>Nature and outdoor adventure</span>
              </li>
              <li className="flex items-start">
                <span className="text-moss-green mr-2">♻️</span>
                <span>Eco-conscious and sustainable practices</span>
              </li>
              <li className="flex items-start">
                <span className="text-moss-green mr-2">❤️</span>
                <span>Treating pets as family members</span>
              </li>
              <li className="flex items-start">
                <span className="text-moss-green mr-2">🐾</span>
                <span>Quality products for adventurous pets</span>
              </li>
            </ul>
          </div>

          <div className="bg-moss-green text-white rounded-lg p-8">
            <h3 className="text-2xl font-bold mb-4">Our Design</h3>
            <p className="mb-4">
              The NorthPet logo uses a forest green and moss green palette that reflects:
            </p>
            <ul className="space-y-3">
              <li className="flex items-start">
                <span className="mr-2">🎨</span>
                <span>Nature and outdoor adventure</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">🌿</span>
                <span>Eco-conscious values</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">🐾</span>
                <span>A playful yet purposeful visual identity</span>
              </li>
            </ul>
            <p className="mt-4">
              This monochromatic green scheme is ideal for sustainable pet gear, accessories, 
              and outdoor pet products.
            </p>
          </div>
        </div>

        {/* Business Information */}
        <div className="mt-8 bg-white rounded-lg p-8 border-2 border-moss-green">
          <h3 className="text-2xl font-bold text-forest-green mb-4 text-center">
            Company Information
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="text-center md:text-left">
              <p className="text-gray-700 mb-2">
                <span className="font-semibold text-forest-green">Corporate Name:</span> NorthPet Inc.
              </p>
              <p className="text-gray-700 mb-2">
                <span className="font-semibold text-forest-green">Corporation Number:</span> 1676559-9
              </p>
              <p className="text-gray-700">
                <span className="font-semibold text-forest-green">Type:</span> Canadian Corporation
              </p>
            </div>
            <div className="text-center md:text-right">
              <p className="text-gray-700 mb-2 font-semibold text-forest-green">
                Registered Office Address:
              </p>
              <p className="text-gray-700">
                35 Selfridge Wy<br />
                Whitby ON L1N 0N9<br />
                Canada 🇨🇦
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
